import type { ElectronContext } from '@mimir/common/context/applicationContext';
import type { Logger } from '@mimir/common/types/logger';
import { exceptionToString } from '@mimir/common/util/exception';
import { ConsoleLogger } from '@mimir/common/util/logging';
import { premiere } from '../../../globals/premiere';
import { startCheckOpenProjectsLoop } from '../../../premiere/checkOpenProjects';
import { logStatistic } from '../../../util/api';
// import { registerNleEventHandlers, unsubscribeNleEventHandlers } from '../../events/handleEvents';
import type { Commit } from 'vuex';

export function enableDvrWorkflowIntegration(applicationContext: ElectronContext, commit: Commit) {
  commit('setDvrWorkflowIntegrationLaunched', true);
  switchDvrMode(applicationContext, commit, true);
  const logger = new ConsoleLogger();
  // registerNleEventHandlers(applicationContext, logger, premiere.clipInfos);

  // startCheckOpenProjectsLoop should take care to not start concurrent looping even if this is
  // called multiple times e.g. for starting the plugin from DVR when it is already running.
  startCheckOpenProjectsLoop(
    applicationContext,
    logger,
    premiere.clipInfos,
  ).catch(err => logger.error(err));

  void logDavinciResolveVersion(applicationContext, logger);
};

export function disableDvrWorkflowIntegration(
  applicationContext: ElectronContext,
  commit: Commit
) {
  // Skip ('./dvr/actions').cleanup() since WIN native module is hanging on during re initialization.
  // We do CleanUp just on ResolveQuit event.
  switchDvrMode(applicationContext, commit, false);
  // unsubscribeNleEventHandlers();
}

// -------- Utility functions --------

function switchDvrMode(applicationContext: ElectronContext, commit: Commit, dvrMode: boolean) {
  applicationContext.setDvrMode(dvrMode);
  commit('setDvrMode', dvrMode);
  commit('setDvrSidebarMenuVisible', dvrMode, { root: true });
}

async function logDavinciResolveVersion(applicationContext: ElectronContext, logger: Logger) {
  try {
    const version = await applicationContext.mainRequire('./dvr/actions').getDvrVersion();
    logger.info(`Running DaVinci Resolve: ${version}`);
    if (version !== null) {
      await logStatistic({ countType: 'davinci_resolve_version', value: version });
    }
  } catch (err) {
    logger.warn(`Failed logging DaVinci Resolve version ${exceptionToString(err)}`);
  }
}